
import jQuery from 'jquery';

import TimeFormat from '@scripts/utilities/time-format.js';


/**
 * Formats any 'server local' times into the users local time in their browser
 */
jQuery(function(jQuery) {
  var localTimes = jQuery('[data-sbm-local-time]');

  if (localTimes.length) {
    for (var i = 0; i < localTimes.length; i++) {
      var item = jQuery(localTimes[i]);

      var timestamp = item.data('sbm-local-time');
      if (timestamp) {
        item.html(
          TimeFormat(timestamp)
        );
      }
    }
  }
});

